var encode = require('./lib/encoder'),
    decode = require('./lib/decoder');

module.exports = {
  encode: encode,
  decode: decode
};



/*****************
 ** WEBPACK FOOTER
 ** /Users/songseunggeun/voxeline/engine/~/save-pixels/~/jpeg-js/index.js
 ** module id = 1123
 ** module chunks = 0
 **/